export default __webpack_public_path__ + "static/media/screenshot_app_skills_purple.28c7e028.png";